import type { ReactNode } from "react";

export type AlertTone = "error" | "info" | "success";

export function Alert({
  tone = "error",
  children,
}: {
  tone?: AlertTone;
  children: ReactNode;
}): ReactNode {
  return (
    <div className={`alert alert--${tone}`} role={tone === "error" ? "alert" : "status"}>
      {children}
    </div>
  );
}
